<template>
  <step-section
    :title="$t('windowType')"
    :loading="loading$"
    :step-number="getStepNumber('windowType')"
  >
    <div class="row row--custom">
      <div
        class="col-6 col-xs-4 col-sm-3 col-md-4 col-lg-3 col-xl-2 col-custom-16 col-small-p"
        v-for="windowType in windowTypes"
        :key="windowType.id"
      >
        <window-type-block
          v-bind="windowType"
          :checked="isItemChecked('windowType.id', windowType.id)"
          @click="handleItemClick(windowType)"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import WindowTypeBlock from '@/components/blocks/WindowTypeBlock.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'WindowTypeStep',
    mixins: [stepMixin],
    props: {
      windowTypes: Array,
    },
    methods: {
      handleItemClick(windowType) {
        this.updateFormField({
          field: 'windowType',
          value: {
            id: windowType.id,
            name: windowType.name,
            photo: windowType.photo,
          },
        });
      },
    },
    components: {
      WindowTypeBlock,
    },
  };
</script>
